/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPedalBikeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-pedal-bike"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 20.25Q2.58 20.25 1.11 18.79Q-0.35 17.32 -0.35 15.05Q-0.35 12.78 1.11 11.31Q2.58 9.85 4.85 9.85Q6.88 9.85 8.22 11.04Q9.57 12.22 9.95 13.95L10.4 13.95L8.6 9.05L7.92 9.05Q7.45 9.05 7.13 8.72Q6.8 8.4 6.8 7.92Q6.8 7.45 7.13 7.13Q7.45 6.8 7.92 6.8L10.97 6.8Q11.45 6.8 11.78 7.14Q12.1 7.47 12.1 8Q12.1 8.43 11.79 8.74Q11.47 9.05 11.05 9.05L11.05 9.05L11.3 9.85L16 9.85L14.55 6Q14.55 6 14.55 6Q14.55 6 14.55 6L13.03 6Q12.55 6 12.22 5.67Q11.9 5.35 11.9 4.88Q11.9 4.4 12.22 4.08Q12.55 3.75 13.03 3.75L14.65 3.75Q15.32 3.75 15.9 4.1Q16.48 4.45 16.7 5.1L18.4 9.8L19.15 9.8Q21.32 9.8 22.84 11.31Q24.35 12.82 24.35 15Q24.35 17.2 22.84 18.73Q21.32 20.25 19.15 20.25Q17.32 20.25 15.9 19.13Q14.47 18 14.05 16.2L9.95 16.2Q9.57 17.98 8.18 19.11Q6.78 20.25 4.85 20.25ZM7.6 16.2L7.6 13.95L5.88 13.95Q5.4 13.95 5.08 14.28Q4.75 14.6 4.75 15.07Q4.75 15.55 5.08 15.88Q5.4 16.2 5.88 16.2ZM12.8 13.95L14.05 13.95Q14.18 13.38 14.35 12.95Q14.53 12.53 14.8 12.1L12.1 12.1ZM17.1 12.85L17.68 14.47Q17.82 14.93 18.25 15.13Q18.68 15.32 19.13 15.15Q19.57 14.97 19.77 14.55Q19.98 14.13 19.8 13.68L19.2 12.1Z" fill={color} />
    </svg>
  );
}
